/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './menu.tpl.html';

/**
 * The top level mobile menu module.
 */
angular.module('mobile.menu', ['sbsf.constants']).controller('MobileMenuCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  '$rootScope',
  'MOBILE_STATES',
  function ($scope, $state, $stateParams, $rootScope, MOBILE_STATES) {
    $scope.previousState = $stateParams.previous;
    $scope.mobileStates = angular.copy(MOBILE_STATES);
    // remove the menu option from the states since we do not want to display it in the menu.
    delete $scope.mobileStates.menu;

    $scope.previousState = $stateParams.previous;
    /**
     * Redirect the app to a different state.
     *
     * @param {string} state - The state to show.
     */
    $scope.goToState = function (state) {
      $state.go(state);
      $rootScope.isAsideMenuOpen = false;
    };

    $scope.toggleAsideMenu = function () {
      $rootScope.isAsideMenuOpen = !$rootScope.isAsideMenuOpen;
    };

    $scope.getCurrentStateName = function () {
      return $state.current.name;
    };
  }
]);
